
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1694"}},[_c('path',{attrs:{"data-name":"Rectangle 2402","fill":"none","d":"M0 0h25v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1693","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1039","d":"M20 6.181a.992.992 0 00-.994-.994H5.994A.993.993 0 005 6.181a7.464 7.464 0 001.734 4.789l-1.359 7.859a1 1 0 00.815 1.157 1.1 1.1 0 00.171.014 1 1 0 00.985-.829l.275-1.589h9.76l.275 1.589a1 1 0 00.985.829 1.118 1.118 0 00.172-.014 1 1 0 00.814-1.157l-1.359-7.86A7.47 7.47 0 0020 6.181zM8.5 12.512a7.444 7.444 0 008.006 0l.531 3.07H7.969z"}}),_c('path',{attrs:{"data-name":"Path 1040","d":"M8.377 4.244a1 1 0 001-1V1a1 1 0 00-2 0v2.244a1 1 0 001 1z"}}),_c('path',{attrs:{"data-name":"Path 1041","d":"M12.502 4.244a1 1 0 001-1V1a1 1 0 00-2 0v2.244a1 1 0 001 1z"}}),_c('path',{attrs:{"data-name":"Path 1042","d":"M16.625 4.244a1 1 0 001-1V1a1 1 0 00-2 0v2.244a1 1 0 001 1z"}})])])])
          )
        }
      }
    